<template>
  <Modal v-model="model" sticky reset-drag-position title="热线号码工作时间定义" @on-cancel="cancel" footer-hide :mask="false" draggable scrollable class="pstnNumber_time" width="1200">
    <Spin size="large" fix v-if="spinShow"><Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon><div>正在加载中...</div></Spin>
    <Tabs v-model="tabName">
      <TabPane label="工作时间" icon="ios-call" name="0">
        <div class="table_head">
          <table>
            <tr>
              <th class="font_style_set" style="width:13%;">
                <Checkbox v-model="monday">星期一</Checkbox>
              </th>
              <th class="font_style_set" style="width:13%;">
                <Checkbox v-model="tuesday">星期二</Checkbox>
              </th>
              <th class="font_style_set" style="width:13%;">
                <Checkbox v-model="wednesday">星期三</Checkbox>
              </th>
              <th class="font_style_set" style="width:13%;">
                <Checkbox v-model="thursday">星期四</Checkbox>
              </th>
              <th class="font_style_set" style="width:13%;">
                <Checkbox v-model="friday">星期五</Checkbox>
              </th>
              <th class="font_style_set" style="width:13%;">
                <Checkbox v-model="saturday">星期六</Checkbox>
              </th>
              <th class="font_style_set" style="width:13%;">
                <Checkbox v-model="sunday">星期日</Checkbox>
              </th>
              <th class="font_style_set" style="width:9%;">操作</th>
            </tr>
          </table>
        </div>
        <div class="footer_style">
          <table class="table_head_footer" style="border-bottom: 1px solid #d1d1d1;">
            <tr v-for="(item , index) in infoTableList" :key="index" :class="{back_color:(index+1)%2==0}">
              <td style="width:13%;">
                <el-time-picker is-range :disabled="!monday" v-model="item.one.time" range-separator="-"  format="HH:mm:ss"  value-format="HH:mm:ss" start-placeholder="开始时间" end-placeholder="截止时间"></el-time-picker>
              </td>
              <td style="width:13%;">
                <el-time-picker is-range :disabled="!tuesday" v-model="item.two.time" range-separator="-"  format="HH:mm:ss"  value-format="HH:mm:ss" start-placeholder="开始时间" end-placeholder="截止时间"></el-time-picker>
              </td>
              <td style="width:13%;">
                <el-time-picker is-range :disabled="!wednesday" v-model="item.three.time" range-separator="-"  format="HH:mm:ss"  value-format="HH:mm:ss" start-placeholder="开始时间" end-placeholder="截止时间"></el-time-picker>
              </td>
              <td style="width:13%;">
                <el-time-picker is-range :disabled="!thursday" v-model="item.four.time" range-separator="-"  format="HH:mm:ss" value-format="HH:mm:ss" start-placeholder="开始时间" end-placeholder="截止时间"></el-time-picker>
              </td>
              <td style="width:13%;">
                <el-time-picker is-range :disabled="!friday" v-model="item.five.time" range-separator="-"  format="HH:mm:ss" value-format="HH:mm:ss" start-placeholder="开始时间" end-placeholder="截止时间"></el-time-picker>
              </td>
              <td style="width:13%;">
                <el-time-picker is-range :disabled="!saturday" v-model="item.six.time" range-separator="-"  format="HH:mm:ss" value-format="HH:mm:ss" start-placeholder="开始时间" end-placeholder="截止时间"></el-time-picker>
              </td>
              <td style="width:13%;">
                <el-time-picker is-range :disabled="!sunday" v-model="item.seven.time" range-separator="-"  format="HH:mm:ss" value-format="HH:mm:ss" start-placeholder="开始时间" end-placeholder="截止时间"></el-time-picker>
              </td>
              <td style="width:9%;" class="template_table_btn">
                <Button @click="deleteWorkTime(index)">删除</Button>
              </td>
            </tr>
          </table>
        </div>
      </TabPane>
      <TabPane label="节假日" icon="ios-home" class="holiday_table" name="1">
        <div class="table_head">
          <table>
            <tr>
              <th class="font_style_set" style="width:4%;"><Checkbox v-model="checkedAll"  @on-change="checkedAllList()"></Checkbox></th>
              <th class="font_style_set" style="width:10%;">月份</th>
              <th class="font_style_set" style="width:10%;">日期</th>
              <th class="font_style_set" style="width:33%;">开始时间</th>
              <th class="font_style_set" style="width:33%;">开始时间</th>
              <th class="font_style_set" style="width:10%;">操作</th>
            </tr>
          </table>
        </div>
        <div class="footer_style">
          <table class="table_head_footer" style="border-bottom: 1px solid #d1d1d1;">
            <tr v-for="(item , index) in holidayList" :key="index" :id="item.id" :class="{back_color:(index+1)%2==0}">
              <td  style="width:4%;"><CheckboxGroup v-model="singleCheckedList"><Checkbox :label="item.id"></Checkbox></CheckboxGroup></td>
              <td style="width:10%;">{{item.month}}</td>
              <td style="width:10%;">{{item.day}}</td>
              <td style="width:33%;">{{item.startTime}}</td>
              <td style="width:33%;">{{item.endTime}}</td>
              <td style="width:10%;" class="template_table_btn">
                <Button  v-if="roleList['3_6-3']" @click="deleteHoliday(item.id)">删除</Button>
              </td>
            </tr>
          </table>
        </div>
      </TabPane>
      <Button type="error" style="margin-left: 15px;" class="cancel_btn" v-if="roleList['3_6-4'] && tabName=='1'"  slot="extra"  @click="deleteHoliday()">批量删除</Button>
      <Button type="success" class="cancel_btn" v-if="roleList['3_6-2'] && tabName=='1'"  slot="extra"  @click="saveHoliday()">添加</Button>
      <el-date-picker v-model="starEndTime" slot="extra"  v-if="tabName=='1'"  unlink-panels type="datetimerange" start-placeholder="开始时间" end-placeholder="结束时间" align="left" :default-time="['00:00:00', '23:59:59']"  :editable="editable" :picker-options="pickerOptions"  format="MM-dd HH:mm:ss"  value-format="MM-dd HH:mm:ss"></el-date-picker>
      <Button type="primary" class="submit_btn" v-if="roleList['3_6-1'] && tabName=='0'" @click="saveWorkTime()" slot="extra">保存</Button>
      <Button type="success" v-if="tabName=='0'"  class="cancel_btn" @click="addWorkTime()" slot="extra" style="margin-right: 15px">添加</Button>
    </Tabs>
  </Modal>
</template>

<script>
    import {publicFunClass} from '@/components/js/PublicFunClass.js'
    import {timeDefinition} from '@/components/js/TimeDefinition.js'
    export default {
      name: "PstnNumberTimePop",
      mixins:[publicFunClass,timeDefinition],
      props:{
        showPstnTime:Boolean,
        pstnNumberId:String
      },
      data(){
        return{
          model:false,
          spinShow:true,
          editable:false,
          pstnNumber:'',
          saveWorkUrl:'pstnNumber/doPstnWorkDaySave.json',
          saveHolidayUrl:'pstnNumber/doPstnHolidaySave.json',
          id:"",
          tabName:'0',
          monday:false,
          tuesday:false,
          wednesday:false,
          thursday:false,
          friday:false,
          saturday:false,
          sunday:false,
          starEndTime:[],
          roleList:JSON.parse(localStorage.getItem("roleList")),
          holidayList:[],
          infoTableList:[],
          singleCheckedList: [],
          checkedAll: false,
        }
      },
      methods:{
        reset: function(){
          this.id = "";
          this.tabName = '0';
          this.pstnNumber = '';
          this.monday = false;
          this.tuesday = false;
          this.wednesday = false;
          this.thursday = false;
          this.friday = false;
          this.saturday = false;
          this.sunday = false;
          this.starEndTime = [];
          this.holidayList = [];
          this.singleCheckedList = [];
          this.infoTableList = [];
          this.checkedAll = false;
        }
      },
      watch:{
        showPstnTime:function () {
          this.model=this.showPstnTime;
          this.pstnNumber=this.pstnNumberId;
          if(this.showPstnTime){
            this.initHolidayTable();
            this.initWorkTable();
          }else{
            this.reset();
          }
        }
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/systemSetup/CTIConfigure/PstnNumberTimePop.vue